import React from 'react';
import type { IPosition, ISize } from '@/version-types';
import { useFramework } from '../hooks';
import { BaseOperateView } from './base-operate-view';

export const BaseScaleView = React.forwardRef<
    HTMLDivElement,
    {
        children?: React.ReactNode;
        style?: React.CSSProperties;
        layer: ISize & IPosition & { rotate?: number };
    }
>(({ children, style, layer }, ref) => {
    const framework = useFramework();
    const scaleRef = React.useRef<HTMLDivElement>(null);
    const scale = framework.service.edgelessCanvas.zoom;

    const syncScale = React.useCallback(() => {
        const node = scaleRef.current;
        if (!node) return;

        const transform = `scale(${framework.service.edgelessCanvas.zoom})`;
        if (node.style.transform !== transform) {
            node.style.transform = transform;
        }
    }, [framework.service.edgelessCanvas]);

    React.useLayoutEffect(() => {
        syncScale();

        const { edgelessCanvas, events } = framework.service;
        const zoomHandle = edgelessCanvas.onZoom(syncScale);

        return () => {
            events.off(zoomHandle);
        };
    }, [framework.service, syncScale]);

    return (
        <BaseOperateView ref={ref} layer={layer} style={style}>
            <div
                ref={scaleRef}
                style={{
                    position: 'relative',
                    width: layer.width,
                    height: layer.height,
                    transform: `scale(${scale})`,
                    transformOrigin: 'left top',
                }}
            >
                {children}
            </div>
        </BaseOperateView>
    );
});
